import { render, staticRenderFns } from "./Specification.vue?vue&type=template&id=ebbea4fe&scoped=true"
import script from "./Specification.vue?vue&type=script&lang=js"
export * from "./Specification.vue?vue&type=script&lang=js"
import style0 from "./Specification.vue?vue&type=style&index=0&id=ebbea4fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbea4fe",
  null
  
)

export default component.exports